import { Root } from '@radix-ui/react-hover-card';

export const HoverCard = Root;
